<template>
  <div class="new-customers bg-white px-4 py-4">
    <p class="text-gray-500 text-sm mb-4" v-if="!isEmpty">New Customers</p>
    <i class="el-icon-refresh float-right text-xl text-red-500 cursor-pointer" v-if="isFailing"></i>
    <div v-if="!isEmpty && !loading && !isFailing">
      <Customer v-for="customer in customers" class="w-5/6 mt-4 " :details="customer"  />
    </div>
    <div v-if="loading">
      <CustomerLoader  v-for="n in 4" />
    </div>
    <EmptyData v-if="!loading && isEmpty && !isFailing" :options="emptyDataOptions" class="mt-32" />
    <EmptyData v-if="!loading && isFailing" :options="errorOptions" class="mt-32" />
  </div>
</template>6

<script>
import CustomerLoader from '../../loaders/customer_loader.vue';
import Customer from './includes/Customer.vue';
import EmptyData from '../../../../Common/components/empty_data.vue';

export default {
  name: 'new_customers',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    customers() {
      return this.$store.state.Dashboard.customers || [];
    },
    emptyDataOptions() {
      return {
        image: 'empty-customer.png',
        text: 'You currently have no new customer for the month.',
        classes: 'w-3/4 italic text-sm',
      };
    },
    errorOptions() {
      return {
        image: 'unavailable.png',
        text: 'We are not able to fetch your data now, please click the refresh icon to try again.',
        classes: 'w-3/4 italic text-sm text-red-500',
      };
    },
  },
  components: {
    CustomerLoader,
    Customer,
    EmptyData,
  },
  methods: {
    async fetchCustomers() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch('Dashboard/fetchCustomers');
        this.isEmpty = response.newCustomers.length < 1;
      } catch (e) {
        this.isFailing = true;
      }

      this.loading = false;
    },
  },
  async mounted() {
    await this.fetchCustomers();
  },
};
</script>

<style scoped lang="scss">
.new-customers {
  flex: 0 1 49%;
  max-height: 700px;
  overflow: hidden;
}
</style>
